const styles = {
  header: {
    backgroundColor: '#fff !important',
    boxShadow:
      '0 .0625em 0 0 rgba(0,0,0,0.03), 0 .125em .375em 0 rgba(0,0,0,0.06)  !important',
    margin: '0 0 1.875em 0  !important',
    width: '100%  !important',
    position: 'fixed !important',
    top: '0 !important',
    zIndex: '1000',
  },
  container: {
    alignItems: 'center !important',
    height: '4.96875em  !important',
    margin: '0 4.8125em  !important',
    padding: '0 !important',
  },
  logo: {
    display: 'flex  !important',
    alignContent: 'center  !important',
    height: '2.5rem !important',
    width: '2.5rem !important',
  },
  break: {
    borderTop: 'solid .0625rem #f5f6f7 !important',
    color: 'transparent !important',
    margin: '0 !important',
    width: '100% !important',
  },
  subHeader: {
    margin: '0 4.8125em  !important',
    padding: '0 !important',
    display: 'flex !important',
    alignItems: 'center !important',
  },
};

export default styles;
